export let isFeatureDev = false;
export let isLocalEnv = false;

export const setFeatureDev = (featureDev = false) => {
  isFeatureDev = featureDev;
};

export const setIsLocalEnv = (localEnv = false) => {
  isLocalEnv = localEnv;
};
